import _extends from "@babel/runtime/helpers/extends";
import { useRouter } from "next/router";
import React from "react";
import SbEditable from "storyblok-react";
import { useStoryblok } from "./StoryblokProvider";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var StoryblokComponent = blok => {
  var _useStoryblok;

  var Components = (_useStoryblok = useStoryblok()) != null ? _useStoryblok : {};
  var {
    isPreview
  } = useRouter(); // check if component is defined above

  if (typeof Components[blok.component] !== "undefined") {
    var Component = Components[blok.component]; // wrap with SbEditable for visual editing

    return isPreview ? /*#__PURE__*/_jsx(SbEditable, {
      content: blok,
      children: /*#__PURE__*/_jsx(Component, _extends({}, blok, {
        isPreview: isPreview
      }))
    }, blok._uid) : /*#__PURE__*/_jsx(Component, _extends({}, blok));
  } // fallback if the component doesn't exist


  return /*#__PURE__*/_jsxs("p", {
    children: ["The component ", /*#__PURE__*/_jsx("strong", {
      children: blok.component
    }), " has not been created yet."]
  });
};
export var renderStoryblokComponents = children => {
  if (!children) return null;

  try {
    return children.map(blok => /*#__PURE__*/_jsx(StoryblokComponent, _extends({}, blok), blok._uid));
  } catch (error) {
    return children;
  }
};
//# sourceMappingURL=StoryblokComponent.js.map